import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaWhatsapp, FaInfoCircle } from "react-icons/fa";
import { supabase } from "../supabaseClient";
import "./PartCard.css";

function PartCard({ id }) {
  const [part, setPart] = useState(null);
  const [views, setViews] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(null);

  useEffect(() => {
    const fetchPart = async () => {
      const { data, error } = await supabase
        .from("parts")
        .select("*")
        .eq("id", id)
        .single();

      if (!error && data) setPart(data);
    };

    const fetchExchangeRate = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("exchange_rate")
        .limit(1)
        .single();
      if (data) setExchangeRate(data.exchange_rate);
    };

    const storedViews = localStorage.getItem(`views_${id}`);
    setViews(storedViews ? parseInt(storedViews, 10) : 0);

    fetchPart();
    fetchExchangeRate();
  }, [id]);

  if (!part) return null;

  const tlPrice = exchangeRate
    ? Math.ceil((part.euro * exchangeRate) / 50) * 50
    : "—";

  return (
    <Link to={`/parca/${id}`} className="modern-card-link">
      <div className="modern-card">
        <div className="image-wrapper">
          <img
            src={part.image_urls?.[0] || "/placeholder.jpg"}
            alt={part.name}
            className="part-image"
          />
          <span className="view-badge">
            <FaEye size={12} style={{ marginRight: 4 }} /> {views}
          </span>
        </div>
        <div className="part-info">
          <h5 className="part-name" title={part.name}>
            {part.name.length > 40 ? part.name.slice(0, 37) + "..." : part.name}
          </h5>

          {part.oem && <div className="oem-code">OEM: {part.oem}</div>}

          <div className="tl-price">₺{tlPrice}</div>

          <div className="compatibility-list">
            {part.compatible_vehicles?.length > 0 ? (
              part.compatible_vehicles.slice(0, 3).map((v, i) => (
                <div key={i} className="vehicle-info">
                  {v.brand} {v.model} ({v.yearFrom}–{v.yearTo})
                </div>
              ))
            ) : (
              <div className="vehicle-info muted">Uyumlu araç bilgisi yok</div>
            )}
          </div>

          <div className="card-buttons">
            <span className="details-button">
              <FaInfoCircle className="me-1" /> Detayları Gör
            </span>
            <a
              href={`https://wa.me/905337308779?text=${encodeURIComponent(
                `Merhaba, ${part.name} parçası hakkında bilgi almak istiyorum.`
              )}`}
              className="whatsapp-button"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <FaWhatsapp className="me-1" /> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default PartCard;